import { t } from "i18next";
import React from "react";
import CustomImageComponent from "./CustomImageComponent";

const Breadcrumb = (props) => {
  const { pathName } = props;

  return (
    <>
      {pathName && (
        <section className="breadcrumb-section">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                {pathName.filter(item => item.name).map((breadcrumb, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${index === pathName.length - 1 ? "active" : ""
                      }`}
                    aria-current={index === pathName.length - 1 ? "page" : null}
                  >
                    {index === pathName.length - 1 ? (
                      breadcrumb?.name
                    ) : (
                      <a href={breadcrumb.path}>
                        {breadcrumb.name.toLowerCase() === "home" || breadcrumb.name === "الرئيسية" ? (
                          <>
                            <CustomImageComponent src={"/assets/img/home.svg"} alt={"Home"} /> {t("home")}
                          </>
                        ) : (
                          breadcrumb?.name
                        )}
                      </a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
          </div>
        </section>
      )}
    </>
  );
};

export default Breadcrumb;
